import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Hexagon } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(window.location.hash.replace("#", ""));
    const sid = params.get("session_id");
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sid });
        setUser(res.data);
        window.history.replaceState(null, "", "/workspace");
        navigate("/workspace", { state: { user: res.data } });
      } catch {
        setError(true);
        setTimeout(() => navigate("/"), 1500);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-background grid-pattern flex flex-col items-center justify-center gap-4" data-testid="auth-callback">
      <Hexagon className="w-10 h-10 text-emerald-400 animate-pulse-dot" />
      <p className="text-slate-400 font-mono text-sm">
        {error ? "Authentication failed. Redirecting…" : "Establishing secure session…"}
      </p>
    </div>
  );
}
